import { WarningOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import React from "react";
import dayjs from "dayjs";

const { Text, Title } = Typography;


interface AlertProps{
    title: string | null;
    date: string | null;
    description: string | null;
}

const Alert : React.FC<AlertProps> = ({ date, description, title }) => {

    const dateTextStyle = {
        color:'gray', 
        fontSize:'12px'
    }
    
    const textStyle = {
        fontWeight:'bold', 
        fontSize:'12px',
    }

    return(
        <Row gutter={16}>
            <Col>
                <WarningOutlined style={{ color: '#faad14', fontSize: '20px', marginTop: '2px' }}/>
            </Col>
            <Col>
                <Row gutter={12}>
                    <Col>
                        <Text strong>{title}</Text>
                    </Col>
                    <Col>
                        <Text style={dateTextStyle}>{dayjs(date).format('MM/DD/YY HH:mm')}</Text>
                    </Col>
                </Row>
                <Row>
                    <Text style ={textStyle}>{description}</Text>
                </Row>
            </Col>
        </Row>
    )
}

export default Alert;